import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/profile/settings")({
  component: SettingsLayout,
})

function SettingsLayout() {
  return <Outlet />
}
